import { createFileRoute } from '@tanstack/react-router'
import { toast } from 'sonner'

import { SetPasswordPage } from '@/pages/set-password-page'
import { isValidSetPasswordUrl } from '@/shared/model'

export const Route = createFileRoute('/_auth/set-password')({
    onEnter: () => {
        document.title = 'Taxoparkee - Установка пароля'
    },
    validateSearch: (
        search: Record<string, unknown>
    ): {
        code: string
        code_uuid: string
    } => {
        return {
            code: `${search.code}`,
            code_uuid: search.code_uuid as string,
        }
    },
    beforeLoad: ({ search }) => {
        if (
            !search.code ||
            !search.code_uuid ||
            !isValidSetPasswordUrl(search.code, search.code_uuid)
        ) {
            toast.error('Ссылка некорректна. Убедитесь, что вы скопировали её полностью', {
                duration: 0,
            })
        }
    },
    component: SetPasswordPage,
})
